import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import * as fromState from './page-state.state'
import { PAGE_STATE_PROFILE_REDUCER } from './page-state.reducer'

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromState.pageStateFeatureKey, PAGE_STATE_PROFILE_REDUCER)
    // effects shouldn't be necessary.
  ]
})
export class PageStateStoreModule {}
